export type Job = {
  id: string;
  payload: string;
  type: string;
  status: JobStatus;
  name: string;
  result?: string | null;
  resultPayload?: JobResultPayload | null;
  started: Date;
  finished: Date;
  createdByName: string;
  createdById: string;
  read: boolean;
};

export type JobResultSummary = {
  conflictCount?: number;
  requiresUserAction?: boolean;
  resolved?: boolean;
  message?: string;
};

export type JobConflict = {
  type: string;
  source: string;
  sourceRow?: number;
  existingEntityId?: string;
  entityType?: string;
  incomingValues?: Record<string, unknown>;
  existingValues?: Record<string, unknown>;
  keyFields?: string[];
  differingFields?: string[];
  metadata?: Record<string, unknown>;
};

export type JobResultPayload = {
  type?: string;
  summary?: JobResultSummary;
  conflicts?: JobConflict[];
  metadata?: Record<string, unknown>;
};

export enum JobStatus {
  STARTED = 'STARTED',
  FINISHED = 'FINISHED',
  PARTIALLY_FINISHED = 'PARTIALLY_FINISHED',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  CREDIT_LIMIT_EXCEEDED = 'CREDIT_LIMIT_EXCEEDED',
}

export enum JobType {
  TOUR_PLANNING_STUDENTS = 'TOUR_PLANNING_STUDENTS',
  TOUR_PLANNING_SPECIAL_TOURS = 'TOUR_PLANNING_SPECIAL_TOURS',
  REROUTE_TOURS = 'REROUTE_TOURS',
  TRANSFORM_PLANNED_TOURS = 'TRANSFORM_PLANNED_TOURS',
  SCHOOL_BASIC_ACCOUNTING = 'SCHOOL_BASIC_ACCOUNTING',
  GLOBAL_EXPORT_PDF = 'GLOBAL_EXPORT_PDF',
  GLOBAL_EXPORT_EXCEL = 'GLOBAL_EXPORT_EXCEL',
  ZIP_EXPORT_EXCEL = 'ZIP_EXPORT_EXCEL',
  ZIP_EXPORT_PDF = 'ZIP_EXPORT_PDF',
  BASIC_REPORT = 'BASIC_REPORT',
  EXCEL_IMPORT = 'EXCEL_IMPORT',
  TRANSPORTATION_NEED_CHECK = 'TRANSPORTATION_NEED_CHECK',
  IMPORT_EMPLOYEES_INTO_KEYCLOAK = 'IMPORT_EMPLOYEES_INTO_KEYCLOAK',
  TEMPLATED_DOCUMENTS = 'TEMPLATED_DOCUMENTS',
}

export enum SelectEnum {
  SELECT_AUTOMATICALLY = 'SELECT_AUTOMATICALLY',
}
